<template lang="pug">
  .evaluatingDeals.blue-background
    .max-width-grid
      h4.white What deals do shoppers look for during the holidays?<span class="super white"><a href="https://www2.deloitte.com/us/en/insights/industry/retail-distribution/holiday-retail-sales-consumer-survey.html" target="_blank">12</a></span>
      p Holiday promotional offers that appeal the most to surveyed shoppers
      IconChart(:items="IconChart" fontColor="black")
</template>

<script>
import IconChart from './IconChart'

export default {
  name: 'evaluatingDeals',
  props: {
  },
  data () {
    return {
      IconChart: [
        {
          icon: 'IconDiscounts',
          number: 95,
          copy: 'Price Discounts',
        },
        {
          icon: 'IconShipping',
          number: 75,
          copy: 'Free Shipping',
        },
        {
          icon: 'IconGifts',
          number: 52,
          copy: 'Free Gifts',
        },
        {
          icon: 'IconLoyalty',
          number: 32,
          copy: 'Loyalty Points',
        },
        {
          icon: 'IconBuySave',
          number: 29,
          copy: 'Buy More, Save More',
        },
        {
          icon: 'IconExchange',
          number: 9,
          copy: 'Exchange Offers',
        },
        {
          icon: 'IconGames',
          number: 6,
          copy: 'Contest, Sweepstakes,<br>and Games',
        },
      ]
    }
  },
  mounted () {
  },
  computed: {
  },
  methods: {
  },
  components: {
    IconChart,
  },
}
</script>

<style scoped lang="scss">
.evaluatingDeals {
  color: #fff;
  padding: 5rem 0;

  h4,
  p {
    text-align: center;
  }

  h4 {
    padding-bottom: 2rem;
  }
}
</style>
